import { Typography, Icon, EmptyCell, type IColumn, Button } from 'shared/ui'
import { type TollFreeProfileNumber } from 'entities/Compliance/model'
import styles from './styles.module.scss'
import { StatusLine } from './StatusLine/StatusLine'

export const getUseCaseColumns = (
  updateStatusAction: (item: TollFreeProfileNumber) => void,
  learnMoreModalAction: () => void
): IColumn<TollFreeProfileNumber>[] => [
  {
    field: 'phoneNumber',
    name: 'Number',
    width: '145px',
    renderRowCell: (row) => (
      <div className={styles.phoneCellWrapper}>
        <Typography variant={'body-md-regular'} ariaLabel={'number'}>
          {row.formattedNumber}
        </Typography>
        {row.isAircall && <Icon icon='aircall' />}
      </div>
    ),
  },
  {
    field: 'inbox',
    name: 'Inbox',
    width: '190px',
    renderRowCell: (row) => {
      if (!row.numberableName) return <EmptyCell />

      return (
        <div className={styles.inboxCellWrapper}>
          <Icon icon='inboxes2' color='var(--content-primary-tertiary)' />
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'number'}
            ellipsis
            tooltipProps={{
              placement: 'top',
              label: row.numberableName,
            }}
          >
            {row.numberableName}
          </Typography>
        </div>
      )
    },
  },
  {
    field: 'status',
    name: 'Status',
    renderRowCell: (row) => (
      <div className={styles.statusCellWrapper}>
        <StatusLine tollFree={row} />
        <div className={styles.checkConditionIcon}>
          {row.isStatusRejected && (
            <Button
              text='Update'
              size={'small'}
              onClick={(event) => {
                event.stopPropagation()
                updateStatusAction(row)
              }}
            />
          )}
          {row.isStatusBlocked && (
            <Button
              size={'small'}
              text={'Learn more'}
              typeBtn={'outlined'}
              contained={'secondary'}
              onClick={(event) => {
                event.stopPropagation()
                learnMoreModalAction()
              }}
            />
          )}
          <Icon icon={'chevronRight'} fontSize={16} color={'var(--content-primary-tertiary)'} />
        </div>
      </div>
    ),
  },
]
